<script lang="ts" setup>
import { computed } from 'vue';

import { RemoveHotelSelectionFiltersOrigin } from '@apps/main/new-desktop/core/models';
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { AppMultiSelectOption } from '@libs/ui';
import type { BoardBasisCode } from '@libs/trip-planner-interfaces';

import type { HotelFilterMealsUpdate } from '../../../hotelFilters';
import { HotelMealFilters } from '../../../hotelFilters';

const { t } = i18n.global;

interface HotelStayFiltersProps {
  options?: AppMultiSelectOption<BoardBasisCode>[];
}

interface HotelStayFiltersEmits {
  (
    eventName: 'meal-option-selected',
    context: {
      filter: HotelFilterMealsUpdate;
      source: RemoveHotelSelectionFiltersOrigin;
    }
  ): void;
}

const emit = defineEmits<HotelStayFiltersEmits>();

const props = defineProps<HotelStayFiltersProps>();

const selectedPlaceholder = computed<string>(() => {
  const selectedOptionsAmount =
    props.options?.filter((option) => option.selected).length ?? 0;

  return t('planner.meal_plan_selected', selectedOptionsAmount);
});

function onSelectOption(selectedOption: HotelFilterMealsUpdate): void {
  emit('meal-option-selected', {
    filter: selectedOption,
    source: RemoveHotelSelectionFiltersOrigin.HotelDetails,
  });
}
</script>

<template>
  <div class="hotel-stay-filters">
    <div class="hotel-stay-filters-wrapper">
      <HotelMealFilters
        v-if="props.options"
        type="modern-light"
        :use-teleport="false"
        :options="props.options"
        :selected-placeholder="selectedPlaceholder"
        :should-show-clear-button="false"
        selected-placeholder-format="x-selected"
        @meal-option-selected="onSelectOption($event)"
      />
      <!-- Free cancelation filter comes here -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hotel-stay-filters {
  padding: var(--spacing-32) 0;
  border-top: 1px solid var(--color-neutral-30);

  @include for-less-or-equal-than-1200-px {
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }
}
</style>
